export type TimerLayoutItem = {
  i: string;
  x: number;
  y: number;
  w: number;
  h: number;
  minW?: number;
  minH?: number;
};

// Split only inside the original header rectangle; never relocate other widgets.
export function adaptTimerHeaderLayout(layout: TimerLayoutItem[]): TimerLayoutItem[] {
  if (layout.some((item) => item.i === 'tournamentName')) return layout;
  const logo = layout.find((item) => item.i === 'logo');
  if (!logo || !Number.isInteger(logo.w) || logo.w < 6) return layout;
  const brandWidth = Math.floor(logo.w / 3);
  if ((logo.minW ?? 1) > brandWidth) return layout;
  return layout.flatMap((item) =>
    item !== logo
      ? [item]
      : [
          { ...item, w: brandWidth },
          {
            i: 'tournamentName',
            x: item.x + brandWidth,
            y: item.y,
            w: item.w - brandWidth,
            h: item.h,
            minW: 2,
            minH: 1,
          },
        ],
  );
}

export const DEFAULT_TIMER_LAYOUT: TimerLayoutItem[] = [
  { i: 'logo', x: 0, y: 0, w: 3, h: 2, minW: 2, minH: 1 },
  { i: 'tournamentName', x: 3, y: 0, w: 6, h: 2, minW: 2, minH: 1 },
  { i: 'level', x: 9, y: 0, w: 3, h: 2, minW: 2, minH: 1 },
  { i: 'sideInfo', x: 0, y: 2, w: 3, h: 6, minW: 1, minH: 3 },
  { i: 'prizePool', x: 0, y: 8, w: 3, h: 2, minW: 1, minH: 1 },
  { i: 'elapsed', x: 0, y: 10, w: 3, h: 2, minW: 1, minH: 1 },
  { i: 'timer', x: 3, y: 2, w: 6, h: 6, minW: 4, minH: 3 },
  { i: 'blinds', x: 3, y: 8, w: 6, h: 4, minW: 4, minH: 2 },
  { i: 'lateReg', x: 9, y: 2, w: 3, h: 2, minW: 1, minH: 1 },
  { i: 'nextLevel', x: 9, y: 4, w: 3, h: 2, minW: 1, minH: 1 },
  { i: 'avgStack', x: 9, y: 6, w: 3, h: 2, minW: 1, minH: 1 },
  { i: 'entries', x: 9, y: 8, w: 3, h: 2, minW: 1, minH: 1 },
  { i: 'rebuyAddon', x: 9, y: 10, w: 3, h: 2, minW: 1, minH: 1 },
  { i: 'marquee', x: 0, y: 12, w: 12, h: 1, minW: 4, minH: 1 },
];
